import React from 'react'
import styled from 'styled-components'
import teamImg from '../../Asset/img/team_spirit.svg';
const CareerHeader = () => {
  return (
    <CareerHeaderWrapper>
      <HeaderItems>
        <LeftBox>
          <h1>Join Us</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti voluptatem saepe modi amet maiores adipisci ipsum sapiente iure in expedita. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti voluptatem saepe modi amet maiores adipisci ipsum sapiente iure in expedita!</p>
          <div className="l-btn">
            More About Us
          </div>
        </LeftBox>
        <RightBox>
          <img src={teamImg} alt="team-spirit" />
        </RightBox>  
      </HeaderItems>
    </CareerHeaderWrapper>
  )
}

const CareerHeaderWrapper = styled.section`
 padding: 100px 20px;
 min-height: 100vh;
`

const HeaderItems = styled.article`
 display: grid;
 grid-template-columns: 60% 38%;
 gap: 2%;

 @media screen and (max-width: 768px) {
  grid-template-columns: 100%;
 }

 @media screen and (max-width: 430px) {
  grid-template-columns: 100%;
 }
`

const LeftBox = styled.article`
 box-shadow: 0 0.5rem 1rem var(--bg-a-color);
 width: 100%;
 height: 70vh;
 transform: translate(0, 5rem);
 h1{
    color: var(--bg-color);
    font-size: 3rem;
    font-weight: 700;
 }

 p{
    color: var(--text-color);
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.7;
    max-width: 600px;
    padding: 10px 0;
 }
 
 .l-btn{
    cursor: pointer;
    border-top: 2px solid var(--bg-color);
    border-left: 2px solid var(--bg-color);
    border-right: 2px solid var(--ico-color);
    border-bottom: 2px solid var(--ico-color);
    border-radius: 50px;
    font-weight: 600;
    text-align: center;
    padding: 12px 0;
    width: 30%;
    margin-top: 10px;
    transition: all 600ms ease-in-out;

    &:hover{
        background: var(--bg-color);
        color: var(--main-color);
    }
 }
 @media screen and (max-width: 430px) {
  p{
    font-size: 15px;
  }
  .l-btn{
    width: 60%
  }
 }
`

const RightBox = styled(LeftBox)`
 background: linear-gradient(var(--main-color), var(--bg-color));
 border-radius: 20rem 0 15rem 20px;
 transform: translate(0, 2rem);

 img{
    width: 100%;
 }
 @media screen and (max-width: 768px) {
  transform: translateY(-10rem);
  border-radius: 12rem 0 8rem 20px;
  height: 40vh;
 }
 @media screen and (max-width: 430px) {
  transform: translateY(-5rem);
  border-radius: 12rem 0 8rem 20px;
  height: 40vh;
 }
`

export default CareerHeader